import React, { useEffect, useState, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
import cross from "assets/images/adduser/cross.svg";
import file from "assets/images/adduser/file.svg";
import fileDark from "assets/images/adduser/fileDark.svg";
import download from "assets/images/adduser/Downloads.svg";
import csvFile from "assets/files/sample.csv";
import crossDark from "assets/images/adduser/crossDark.svg";
// import Papa from "papaparse";
import useTheme from "hooks/observer";
import * as XLSX from "xlsx";

import "./multipleusermodal.scss";

const MultipleUserModal = ({
  title,
  description,
  setMultipleUserModal,
  setUserlist,
  setState = false,
  setListName = ""
}) => {
  const theme = useTheme();
  const closeIcon = theme === "light" ? cross : crossDark;
  const fileIcon = theme === "light" ? file : fileDark;
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");
  const [progress, setProgress] = useState(0);
  const [csvData, setCsvData] = useState([]);

  // const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const allowedFileTypes = [
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ];
  const maxFileSize = 2 * 1024 * 1024;
  const duration = 1000;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  const handleFileValidation = (file) => {
    if (!allowedFileTypes.includes(file.type)) {
      setError(
        "Invalid file type. Please upload a file with extension .csv, .xls or .xlsx."
      );
      setSelectedFile(null);
      return false;
    }

    if (file.size > maxFileSize) {
      setError(
        "File size exceeds the 2 MB limit. Please upload a smaller file."
      );
      setSelectedFile(null);
      return false;
    }

    setError("");
    return true;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validExtensions = [".csv", ".xls", ".xlsx"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!validExtensions.includes(`.${fileExtension}`)) {
      console.error(
        "Invalid file type. Please upload a CSV, XLS, or XLSX file."
      );
      return;
    }

    // File validation passed
    setSelectedFile(file);

    // Handle CSV files
    if (fileExtension === "csv") {
      // Papa.parse(file, {
      //   header: true,
      //   skipEmptyLines: true,
      //   complete: (result) => {
      //     setCsvData(result.data);
      //   },
      //   error: (error) => {
      //     console.error("Error parsing CSV file:", error);
      //   }
      // });
      console.warn("Should read file");
    } else if (fileExtension === "xls" || fileExtension === "xlsx") {
      // Handle Excel files
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0]; // Get the first sheet
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]); // Convert to JSON
        setCsvData(sheetData); // Use the same state to store data
      };
      reader.onerror = (error) => {
        console.error("Error reading Excel file:", error);
      };
      reader.readAsArrayBuffer(file); // Read the file as binary
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const downloadCsv = () => {
    const link = document.createElement("a");
    link.href = csvFile;
    link.download = "sample.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (!selectedFile) return;

    setProgress(0);

    const step = 100 / (duration / 100);
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + step;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [selectedFile, duration]);

  const resetFile = () => {
    setSelectedFile(null);
    setProgress(0);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file && handleFileValidation(file)) {
      setSelectedFile(file);
    }
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (progress == 100) {
      // navigate("/userlist", { state: { csvData } });
      setMultipleUserModal(false);
      setUserlist(csvData);
      setState(true);
      setListName("multiple user");
    }
  }, [progress]);
  return (
    <div className="modalOver">
      <div className="modalContainer">
        <img
          src={closeIcon}
          alt="cross"
          className="cross"
          onClick={() => setMultipleUserModal(false)}
        />
        <div className="modalHeader">
          <h2 className="modalTitle">{title}</h2>
          <p className="modalDescription">{description}</p>
        </div>
        <div
          className={`modalMain ${selectedFile ? "selected" : ""}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
        >
          <div className="file">
            <img src={fileIcon} alt="file" className="fileIcon" />
            {selectedFile?.name && (
              <div className="fileDetails">
                <p className="fileName">{selectedFile?.name}</p>
                <p className="fileSize">
                  File Size: {(selectedFile?.size / (1024 * 1024)).toFixed(2)}{" "}
                  MB
                </p>
              </div>
            )}
          </div>
          {!selectedFile?.name && (
            <div className="validation">
              <p className="dropText">
                Drop your file here, or
                <span onClick={handleBrowseClick}>Browse</span>
              </p>
              <div className="size">
                <p>Max file size: 2 MB,</p>
                <p>Supports: csv, xlsx, xls.</p>
              </div>
              {error && <p className="error">{error}</p>}
            </div>
          )}
          {selectedFile?.name && progress > 0 && (
            <div className="progress">
              <div className="progressContainer">
                <div
                  className="progressBar"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <div className="progressPercentage">
                <p>{Math.floor(progress)}%</p>
              </div>
              <img
                src={closeIcon}
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={resetFile}
                className="close"
              />
            </div>
          )}
          <input
            ref={fileInputRef}
            id="fileInput"
            type="file"
            style={{ display: "none" }}
            onChange={handleFileChange}
            accept=".csv, .xlsx, .xls"
          />
        </div>
        <div className="footer" onClick={downloadCsv}>
          <div className="download">
            <img src={download} alt="download" />
          </div>
          <p className="btnText">Sample_File.csv</p>
        </div>
      </div>
    </div>
  );
};

export default MultipleUserModal;
